import IOrder from "@models/IOrder";
import IOrder_Progress_State from "@models/IOrder_Progress_State";
import OwButton from "../OwButton/OwButton";
import { useContext, useEffect, useRef, useState } from "react";
import SupplierContext from "@contexts/SupplierContext";
import { SquareContext } from "@contexts/SquareContext";
import { OrderPaymentSquareNewCard } from "./OrderPaymentSquareNewCard/OrderPaymentSquareNewCard";
import { useSquareWebSdk } from "@hooks/integrations/useSquareWebSdk";
import { OrderPaymentSquareCharge } from "./OrderPaymentSquareCharge/OrderPaymentSquareCharge";

type Props = {
    orderModel: IOrder;
    cancelFn: (refresh?: boolean) => void;
    confirmFn: (refresh?: boolean) => void;
    nextStep?: IOrder_Progress_State;
};

export const OrderPaymentSquare = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    const [slide, setSlide] = useState(0);
    const [existingCard, setExistingCard] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [processingCompleted, setProcessingCompleted] = useState(false);

    const nextSlide = () => {
        if (slide < 2) {
            // Only go to slide 2 max (since we have 3 slides)
            setSlide(slide + 1);
        }
    };

    const prevSlide = () => {
        if (slide > 0) {
            // Only go to slide 0 min
            setSlide(slide - 1);
        }
    };

    return (
        <div className={"OrderPaymentSquare"}>
            <SquareContext.Provider value={{ isLoading, setIsLoading, nextSlide, prevSlide, processingCompleted, setProcessingCompleted }}>
                {processingCompleted ? null : (
                    <div className="text-end">
                        <OwButton
                            className="btn-danger"
                            centerIconClass="fas fa-times"
                            fn={() => {
                                props.cancelFn();
                            }}
                        />
                    </div>
                )}
                <div>
                    <div className={`slides-container slide-${slide}`}>
                        <div className={"payment-slide h-100"}>
                            <OrderPaymentSquareCharge orderModel={props.orderModel} cancelFn={props.cancelFn} confirmFn={props.confirmFn} />
                        </div>
                    </div>
                </div>
            </SquareContext.Provider>
        </div>
    );
};
